import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import BasicLayout from '@/layouts/BasicLayout';
/**
 * 专题-模块
 */

var _native = {
  path: '/native',
  redirect: '/special',
  name: 'Native',
  component: BasicLayout,
  children: [{
    path: 'artworkDetail',
    // 画作详情
    name: 'ArtworkDetail',
    component: function component() {
      return import('views/native/ArtworkDetail');
    },
    meta: {
      title: '画作介绍',
      hasNoHead: true
    }
  }, {
    path: 'help',
    // 帮助中心
    name: 'NativeHelp',
    component: function component() {
      return import('views/native/Help');
    }
  }, {
    path: 'registerProtocol',
    // 用户协议
    name: 'NativeRegister',
    component: function component() {
      return import('views/native/protocol/Register');
    }
  }, {
    path: 'beginnerGuide',
    // 新手指南
    name: 'BeginnerGuide',
    meta: {
      title: '新手指南'
    },
    component: function component() {
      return import('views/native/protocol/BeginnerGuide');
    }
  }, {
    path: 'privacyProtocol',
    // 隐私协议
    name: 'NativePrivacy',
    component: function component() {
      return import('views/native/protocol/Privacy');
    }
  }, {
    path: 'copyWriting',
    // 综合页面
    name: 'CopyWriting',
    component: function component() {
      return import('views/native/CopyWriting');
    }
  }, {
    path: 'audioPlay',
    // 音频播放页
    name: 'nativeAudioPlay',
    component: function component() {
      return import('views/native/AudioPlay');
    }
  }, {
    path: 'messageList',
    // 消息列表页
    name: 'MessageList',
    component: function component() {
      return import('views/native/MessageList');
    },
    meta: {
      title: '消息中心'
    }
  }, {
    path: 'crowdfundingService',
    name: 'CrowdfundingService',
    component: function component() {
      return import('views/native/CrowdfundingService');
    },
    meta: {
      title: '商品众筹服务协议'
    }
  }]
};
export default _native;